/**
 * The ONE null bucket every content-label surface renders (`components-ui/ContentLabelValue.tsx` draws it).
 * In metrics and the bookmark filter null means "unlabeled OR needs a decision"; the Content tab's Unlabeled
 * filter is STRICT and never matches needs-decision contents. Node-safe: no React, Apollo or generated types.
 */

export const CONTENT_LABEL_BUCKET_NAME = 'Unlabeled';

/**
 * The one id sentinel, shared by the Performance grouping row key, the chart
 * band id, the Optimize table row key and the Filters drawer's Set member.
 *
 * Four surfaces means four chances to invent a slightly different sentinel and
 * for a selection made in one to silently fail to match the row in another, so
 * there is exactly one, and it is shaped so it can never collide with a real
 * `contentLabelCategoryValueId` uuid.
 */
export const CONTENT_LABEL_NULL_BUCKET_ID = '__content-label-unlabeled__';

/**
 * The Content tab's "Need decision" row: its Set member beside the Unlabeled sentinel, shaped the same
 * way so it never collides with a value uuid, and its copy (CoveragePills' noun). Only this row brings
 * in needs-decision contents; that tab's Unlabeled never does.
 */
export const CONTENT_LABEL_NEEDS_DECISION_ID = '__content-label-needs-decision__';
export const CONTENT_LABEL_NEEDS_DECISION_NAME = 'Need decision';

/** Figma's own `#41424E`, which already measures 9.93:1 on white. */
export const UNLABELED_GREY_ON_LIGHT = '#41424E';

/**
 * One stop lighter than Figma's dark-menu `#8A8C9E`, which measures 4.29:1 on
 * `#2A2A32` — a near miss. This is 5.97:1.
 */
export const UNLABELED_GREY_ON_DARK = '#A6A7B5';

/**
 * The bucket's chart-series colour, for the stacked bands and funnel groups.
 * The same neutral as the table rows.
 */
export const CONTENT_LABEL_BUCKET_COLOR = UNLABELED_GREY_ON_LIGHT;
